module.exports = __webpack_public_path__ + "static/img/img-lose.c7503fc6.png";